import { Injectable } from "@angular/core";
import { environment } from "../environments/environment.production";
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class SolicitarCertificadoEstatalMoralService {

  constructor(private http: HttpClient){

  }

  private endPoint: string = `${environment.HOST}/solicitarCertificadoEstatalMoral`;

  solicitarCertificdo(data: any){
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(this.endPoint, data, { headers });
  }

}
